// aiApp/components/Bots/Image/styled.js
import styled from "styled-components";
import { keyframes } from "styled-components";
import artistDetails from "../../Assets/artistDetails.png";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const loadingSpinner = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const circleComplete = keyframes`
  0% {
    stroke-dasharray: 50, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15;
  }
  100% {
    stroke-dasharray: 200, 200;
    stroke-dashoffset: -100;
  }
`;

const checkmarkAppear = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const ChatbotContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 104px);
  width: calc(100vw - 200px);
  
  overflow: hidden;
  position: fixed;
  top: 104px;
  left: 200px;
  @media (max-width: 1124px) {
    flex-direction: column;
    height: calc(100vh - 104px);
   width: calc(100vw - 70px);
    top: 104px;
     left: 70px;
  }

  @media (max-width: 768px) {
    gap: 10px;
    height: 100vh;
    top: 2px;
    left: 0;
  }
`;

export const ChatbotMain = styled.div`
  flex: 2;
  height: 100%;
  width: 66.66vw;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
  }

  @media (max-width: 1124px) {
    flex: none;
    width: calc(100vw - 70px);
    left: 70px;
    height: 50vh;
    padding: 15px;
  }

  @media (max-width: 768px) {
    height: ${({ isDetailsExpanded }) => (isDetailsExpanded ? "20vh" : "60vh")};
    ${({ isDetailsPanelVisible }) => (!isDetailsPanelVisible && `height: 100vh`)};
    padding: 10px;
    padding-bottom: ${({ isDetailsPanelVisible }) =>
      isDetailsPanelVisible ? "0" : "60px"};
  }
`;

export const ChatbotDetailsPanel = styled.div`
  flex: 1;
  height: 100%;
  width: 33.33vw;
  background-color: ${({ theme }) => theme.color.imageDarkGrey || "#1a1a1a"};
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  border-radius: 4px 0 0 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
  }

 @media (max-width: 1124px) {
    flex: 1;
    width: calc(100vw - 70px);
    left: 70px;
    height: 50vh;
    padding: 15px;
    border: 1px solid ${({ theme }) => theme.color.spotifyLightGrey};
    border-bottom: none;
    border-right: none;
  }

  @media (max-width: 768px) {
    height: ${({ isDetailsExpanded }) => (isDetailsExpanded ? "80vh" : "40vh")};
    padding: 60px 10px 10px 10px;
    background-color: ${({ isImage, theme }) =>
      isImage ? theme.color.imageDarkGrey || "#1a1a1a" : theme.color.imageDarkGrey || "#1a1a1a"};
    transition: height 0.3s ease;
    position: relative;
  }
`;

export const ChatbotForm = styled.form`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  ${({ isImage }) => isImage && `margin-top: 30px;`}

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: ${({ theme }) => theme.color.imageBlack || "#121212"};
    padding: 10px;
    margin-bottom: 0;
  }
`;

export const ChatbotInput = styled.input`
  flex: 1;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.color.imageDarkGrey || "#1a1a1a"};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.imageWhite || "#ffffff"};
  font-size: 14px;
  outline: none;
  transition: background-color 0.2s ease;
  height: 40px;
  line-height: 1;
  box-sizing: border-box;

  &:focus {
    background-color: ${({ isImage, theme }) =>
      isImage ? theme.color.imageLightGrey || "#2a2a2a" : theme.color.imageLightGrey || "#2a2a2a"};
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 12px;
    height: 34px;
  }
`;

export const ChatbotExpandButton = styled.button`
  display: none;
  padding: 8px 16px;
  background-color: ${({ isImage, theme }) =>
    isImage ? theme.color.imageLightGrey || "#2a2a2a" : theme.color.imageLightGrey || "#2a2a2a"};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.imageWhite || "#ffffff"};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 10px;

  &:hover {
    background-color: ${({ isImage, theme }) =>
      isImage ? theme.color.imageGrey || "#4a4a4a" : theme.color.imageGrey || "#4a4a4a"};
  }

  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: ${({ isDetailsExpanded }) =>
      isDetailsExpanded ? "calc(20vh + 20px)" : "calc(60vh + 20px)"};
    left: 10px;
    z-index: 10;
  }
`;

export const ChatbotDetailsHeader = styled.div`
  display: none;
  position: fixed;
  top: 60vh;
  left: 0;
  right: 0;
  height: 60px;
  background-color: ${({ isImage, theme }) =>
    isImage ? theme.color.imageDarkerGrey || "#151515" : theme.color.imageDarkerGrey || "#151515"};
  z-index: 9;

  &:after {
    content: "";
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${({ isImage, theme }) =>
      isImage ? theme.color.imageLightGrey || "#2a2a2a" : theme.color.imageLightGrey || "#2a2a2a"};
  }

  @media (max-width: 768px) {
    display: block;
    top: ${({ isDetailsExpanded }) => (isDetailsExpanded ? "19.8vh" : "60vh")};
  }
`;

export const ChatbotError = styled.div`
  margin-top: 20px;
  color: #ff4d4d;
  font-size: 16px;

  @media (max-width: 768px) {
    ${({ isImage }) => isImage && `margin-top: 160px;`}
    font-size: 14px;
  }
`;

export const AppTitle = styled.h1`
  color: ${({ isImage, theme }) =>
    isImage ? theme.color.tileTitle : theme.color.tileTitle};
  font-size: 24px;
  margin-bottom: 25px;
  text-align: center;
  @media (min-width: 768px) {
    margin-top: 0px;
  }
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    margin: 0;
    background-color: ${({ theme }) => theme.color.imageBlack || "#121212"};
    z-index: 11;
  }
`;

export const LoadingElement = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  color: #666;

  &::after {
    content: "";
    width: 16px;
    height: 16px;
    border: 2px solid #666;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin-loading 1s linear infinite;
  }

  @keyframes spin-loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    ${({ isImage }) => isImage && `margin-top: 145px;`}
  }
`;

export const ImageWrapper = styled.div`
  @media (max-width: 768px) {
   display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  }
`;

export const ImageDisplay = styled.img`
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
  margin-top: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    max-height: 50vh;
   margin-top: 200px;
  }
`;

export const CopyButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
    align-items: center;
    justify-content: center;
    margin-bottom: 70px;
  }
`;

export const DownloadButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
  align-items: center;
    justify-content: center;
    margin-bottom: 70px;
  }
`;

export const CopyButton = styled.button`
  padding: 10px 20px;
  background-color: ${({ isLawyer, isFacebook, theme }) =>
    isLawyer
      ? theme.color.lawyerLightBlue
      : isFacebook
      ? theme.color.facebookBlue
      : theme.color.spotifyDarkGreen};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: ${({ isUnderImage }) => (isUnderImage ? "20vh" : "50%")};
  box-sizing: border-box;
  position: relative; /* Dodajemy position: relative, aby SuccessCheckmark był pozycjonowany względem CopyButton */

  &:hover {
    background-color: ${({ isLawyer, isFacebook, theme }) =>
      isLawyer
        ? theme.color.lawyerGold
        : isFacebook
        ? theme.color.facebookBrightBlue
        : theme.color.spotifyBrightGreen};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.spotifyGrey};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
    width: 50%;
  }
`;

export const SuccessCheckmark = styled.div`
  width: 24px;
  height: 24px;
  position: absolute; /* Pozycjonowanie absolutne względem CopyButton */
  top: 50%; /* Centrujemy pionowo */
  left: calc(100% + 8px); /* Umieszczamy tuż po prawej stronie CopyButton z odstępem 8px */
  transform: translateY(-50%); /* Korekta pionowego wyśrodkowania */
  z-index: 1; /* Upewniamy się, że ikona jest na wierzchu */

  .loading-circle {
    width: 24px;
    height: 24px;
    animation: ${loadingSpinner} 1s linear infinite;
  }

  .loading-circle circle {
    fill: none;
    stroke: #4caf50;
    stroke-width: 2;
    stroke-linecap: round;
    animation: ${circleComplete} 1.5s ease-in-out forwards;
  }

  .checkmark {
    position: absolute;
    top: 20%;
    left: 40%;
    transform: translate(-50%, -50%);
    color: #4caf50;
    font-size: 14px;
    font-weight: bold;
    opacity: 0;
    animation: ${checkmarkAppear} 0.3s ease-in-out 1.2s forwards;
  }

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    left: calc(100% + 6px); /* Mniejszy odstęp na urządzeniach mobilnych */
    top: 50%;
    transform: translateY(-50%);

    .loading-circle {
      width: 20px;
      height: 20px;
    }

    .checkmark {
      font-size: 12px;
    }
  }
`;

export const ChatbotSelect = styled.select`
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.color.imageDarkGrey || "#1a1a1a"};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.imageWhite || "#ffffff"};
  font-size: 14px;
  outline: none;
  transition: background-color 0.2s ease;
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;

  &:focus {
    background-color: ${({ theme }) => theme.color.imageLightGrey || "#2a2a2a"};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.imageGrey || "#4a4a4a"};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 12px;
    height: 34px;
  }
`;

export const ArtistImage = styled.img.attrs({
  src: artistDetails,
  alt: "Artist Details"
})`
  max-width: 50%;
  height: auto;
  margin: 15px auto 0;
  border-radius: 4px;
  object-fit: contain;
   display: block;
`;